const config = {
  features: {
    enableFloodAlerts: false, // Temporarily disabled
    enableEmergencyCall: process.env.NEXT_PUBLIC_ENABLE_EMERGENCY_CALL === 'true',
    enableChatbot: process.env.NEXT_PUBLIC_ENABLE_CHATBOT === 'true' || process.env.NODE_ENV === 'test', // Enabled for testing
    enableContactForm: true, // New contact form is enabled
    enableFaq: true, // Re-enabled FAQ page
    enableEmergencyPage: true, // Feature toggle for Emergency page (default off)
    enableFacebookLink: process.env.NEXT_PUBLIC_ENABLE_FACEBOOK === 'true',
    enableTwitterLink: process.env.NEXT_PUBLIC_ENABLE_TWITTER === 'true',
    enableTelegramLink: process.env.NEXT_PUBLIC_ENABLE_TELEGRAM === 'true',
    enableContractorSignup: true, // Re-enabled as requested
    enableCallTracking: process.env.NEXT_PUBLIC_ENABLE_CALL_TRACKING !== 'false',
    // Only enable ads in production environment, show placeholders in dev/UAT
    enableAds: process.env.NODE_ENV === 'production' && process.env.NEXT_PUBLIC_ENABLE_ADS !== 'false',
    enablePremium: true, // Re-enabled as requested
    enableBlog: process.env.NEXT_PUBLIC_ENABLE_BLOG === 'true', // Blog feature toggle
    enableReviews: process.env.NEXT_PUBLIC_ENABLE_REVIEWS !== 'false', // Reviews feature toggle
    showAdPlaceholders: process.env.NODE_ENV !== 'production', // Show placeholders in non-prod environments
    enableDoorwayPages: process.env.DOORWAY_PAGES_ENABLED === 'true',
  },
  api: {
    baseUrl: process.env.NEXT_PUBLIC_API_BASE_URL || 'http://localhost:8000',
    endpoints: {
      contractors: '/api/contractors',
      floodAlerts: '/api/flood-alerts',
      chatbot: '/api/chatbot',
      emergencyInfo: '/api/emergency',
      search: '/api/search',
      callMetrics: '/api/call-metrics'
    }
  },
  database: {
    // Use environment variables exclusively to avoid hardcoding
    host: process.env.DB_HOST,
    port: parseInt(process.env.DB_PORT || '5432'),
    name: process.env.DB_NAME,
    user: process.env.DB_USER,
    password: process.env.DB_PASSWORD,
  },
  // Redis configuration
  redis: {
    // Whether Redis is enabled at all
    enabled: process.env.REDIS_ENABLED !== 'false', // Default to true if not explicitly set to false
    
    // Redis connection details
    host: process.env.REDIS_HOST || 'localhost',
    port: parseInt(process.env.REDIS_PORT, 10) || 6379,
    password: process.env.REDIS_PASSWORD || '',
    url: process.env.REDIS_URL || null,
    
    // Search configuration
    enableSearch: process.env.REDIS_SEARCH_ENABLED !== 'false', // Default to true if not explicitly set to false
    searchTtl: parseInt(process.env.REDIS_SEARCH_TTL, 10) || 86400, // 1 day in seconds
    
    // Logging and diagnostics
    verbose: process.env.REDIS_VERBOSE === 'true' || process.env.NODE_ENV !== 'production'
  },
  // Subscription plans configuration
  subscriptions: {
    // Default plan when none is specified (environment configurable)
    defaultPlan: process.env.DEFAULT_SUBSCRIPTION_PLAN || 'BASIC',
    // Plan tiers in order of precedence (highest to lowest)
    planTiers: {
      SPONSORED: 1,
      PREMIUM: 2,
      VERIFIED: 3,
      ADSENSE: 4,
      BASIC: 5,
      FREE: 6
    }
  },
  googleMaps: {
    apiKey: process.env.GOOGLE_MAPS_API_KEY || 'AIzaSyBQbioiThKigxb1NDVFU2gOESndTlEj3lQ',
  },
  callrail: {
    enabled: process.env.CALLRAIL_ENABLED === 'true',
    apiKey: process.env.CALLRAIL_API_KEY || 'f0b8efc27146b73e69fe00d9ead1bd3a',
    accountId: process.env.CALLRAIL_ACCOUNT_ID || '940728551',
    companyId: process.env.CALLRAIL_COMPANY_ID || '',
    webhookSecret: process.env.CALLRAIL_WEBHOOK_SECRET || '',
  },
  leadTracking: {
    callsEnabled: process.env.NEXT_PUBLIC_ENABLE_CALL_TRACKING !== 'false',
    clicksEnabled: process.env.NEXT_PUBLIC_ENABLE_CLICK_TRACKING !== 'false',
  },
  ads: {
    // Only enable real ad code in production environment
    enabled: process.env.NODE_ENV === 'production' && process.env.NEXT_PUBLIC_ENABLE_ADS !== 'false',
    // Always use environment variable for AdSense ID, never hardcode
    googleAdSenseId: process.env.NEXT_PUBLIC_GOOGLE_ADSENSE_ID || '',
    // Use placeholders in non-production environments
    usePlaceholders: process.env.NODE_ENV !== 'production',
    slots: {
      leaderboard: process.env.NEXT_PUBLIC_ADSENSE_SLOT_LEADERBOARD || '',
      mediumRectangle: process.env.NEXT_PUBLIC_ADSENSE_SLOT_MEDIUM_RECTANGLE || '',
      sidebar: process.env.NEXT_PUBLIC_ADSENSE_SLOT_SIDEBAR || '',
      mobileSticky: process.env.NEXT_PUBLIC_ADSENSE_SLOT_MOBILE_STICKY || '',
      inline: process.env.NEXT_PUBLIC_ADSENSE_SLOT_INLINE || '',
      footer: process.env.NEXT_PUBLIC_ADSENSE_SLOT_FOOTER || '',
    }
  },
  siteUrl: process.env.NEXT_PUBLIC_BASE_URL || 'https://waterdamagedirect.com',
  telegram: {
    bot_token: process.env.TELEGRAM_BOT_TOKEN,
    review_channel_id: process.env.TELEGRAM_REVIEW_CHANNEL_ID,
    chat_id: process.env.TELEGRAM_CHAT_ID
  },
  stripe: {
    secretKey: process.env.STRIPE_SECRET_KEY || 'sk_test_51QzBJjAN4sWu2nsKnHs1gUp0Kw5PjtmAFYWucZL4JOVzxfg7gy714RyHJnsS3MIejxlH7nuLBLcvIefRYGo5SefV00eVfgSNDL',
    publicKey: process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY || 'pk_test_51QzBJjAN4sWu2nsK6Ev9j9x2aytYajOsDRb0CN5Yk0CYwT15xpYwfbPj6wdlNYHL1BBoXG6OZsoA4YK9lH3pQacW00NqXU0jgu',
    webhookSecret: process.env.STRIPE_WEBHOOK_SECRET || 'whsec_prod_webhook_secret_key_2a3b4c5d6e7f',
    launchSpecialMonthlyPriceId: process.env.STRIPE_LAUNCH_SPECIAL_MONTHLY_PRICE_ID || 'price_premium_monthly_99',
    launchSpecialYearlyPriceId: process.env.STRIPE_LAUNCH_SPECIAL_YEARLY_PRICE_ID || 'price_premium_yearly_999',
    standardPremiumMonthlyPriceId: process.env.STRIPE_STANDARD_PREMIUM_MONTHLY_PRICE_ID || 'price_sponsored_monthly_150',
    standardPremiumYearlyPriceId: process.env.STRIPE_STANDARD_PREMIUM_YEARLY_PRICE_ID || 'price_sponsored_yearly_1500'
  },
  stealth: {
    password: process.env.STEALTH_PASSWORD || 'waterprotect'
  }
};

module.exports = config;